import { BrowserRouter, useRoutes } from 'react-router-dom'
import { AppProviders, type AppProvidersProps } from './app/providers'
import { routes } from './app/routes'
import './styles/index.css'

function AppRoutes() {
  return useRoutes(routes)
}

export type AppProps = Omit<AppProvidersProps, 'children'>

export function App(props: AppProps) {
  return (
    <AppProviders {...props}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AppProviders>
  )
}
